import { Box, Circle, Flex, Icon, SimpleGrid } from "@chakra-ui/core"
import React, { useState } from "react"
import { FiXCircle } from "react-icons/fi"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { GameDetailsPageData } from "../types"
import Screenshot from "./Screenshot"

interface Props {
  data: GameDetailsPageData
}

const GameScreenshots: React.FC<Props> = ({ data }) => {
  const [showGallery, setShowGallery] = useState(false)
  const enableGallery = () => setShowGallery(true)
  const disableGallery = () => setShowGallery(false)

  return (
    <>
      <Box
        color="gray.200"
        padding={6}
        backgroundColor="gray.900"
        // onClick={enableGallery}
      >
        <SimpleGrid columns={{ base: 1, sm: 4 }} spacing={3}>
          {data.screenshots.featured.map(s => {
            return (
              <Box boxShadow="lg" key={s}>
                <Screenshot gameId={data.gameId} id={s} />
              </Box>
            )
          })}
        </SimpleGrid>
      </Box>
      <Gallery
        isOpen={showGallery}
        onClose={disableGallery}
        gameId={data.gameId}
        imageIds={data.screenshots.featured}
      />
    </>
  )
}

interface GalleryProps {
  isOpen: boolean
  gameId: string
  imageIds: string[]
  onClose: () => void
}

const Gallery: React.FC<GalleryProps> = ({
  isOpen,
  gameId,
  imageIds,
  onClose,
}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  if (!isOpen) {
    return null
  }

  return (
    <>
      <Box
        position="absolute"
        width="100%"
        height="100%"
        top={0}
        left={0}
        backgroundColor="black"
        opacity={0.8}
        onClick={onClose}
      ></Box>
      <Box position="absolute" top={0}>
        <Box
          position="fixed"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="60%"
          maxWidth="400px"
        >
          <Flex justifyContent="flex-end" mb={3}>
            <Circle onClick={onClose}>
              <Icon as={FiXCircle} boxSize={50} />
            </Circle>
          </Flex>
          <Carousel {...settings} className="presentation-mode">
            {imageIds.map(s => {
              return (
                <Box key={s}>
                  <Screenshot gameId={gameId} id={s} />
                </Box>
              )
            })}
          </Carousel>
        </Box>
      </Box>
    </>
  )
}

export default GameScreenshots
